/**
 * Content hook — Module 3 editorial strategy.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api';

export interface ContentPillar {
  name: string;
  description: string;
  color: string;
}

export interface PostIdea {
  pillar: string;
  platform: string;
  format: string;
  day: string;
  title: string;
  hook: string;
  cta: string;
}

export interface ContentPlan {
  lang?: string;
  stale?: boolean;
  pillars: ContentPillar[];
  post_ideas: PostIdea[];
  cadence: string;
}

export function useContent() {
  const qc = useQueryClient();

  const query = useQuery<ContentPlan | null>({
    queryKey: ['content'],
    queryFn: () => apiRequest<ContentPlan | null>('/content'),
  });

  const generate = useMutation({
    mutationFn: () => apiRequest<ContentPlan>('/content/generate', { method: 'POST' }),
    onSuccess: (plan) => qc.setQueryData(['content'], plan),
  });

  return {
    plan: query.data ?? null,
    isLoading: query.isLoading,
    generate,
  };
}
